import authAxios from "../common/authAxios";

class AetService {
  /* AET REGIONS */
  async getAllRegions() {
    return await authAxios.get("/aet/region/get-all");
  }

  async getAllRegionsByIsUsedTrue() {
    return await authAxios.get("/aet/region/get-all-by-is-used-true");
  }

  async getRegionById(id) {
    return await authAxios.get(`/aet/region/get-by-id?id=${id}`);
  }

  async deleteRegion(id) {
    return await authAxios.delete(`/aet/region/delete-region?id=${id}`);
  }

  async createRegion(name, isUsed) {
    return await authAxios.post(`/aet/region/create-region?name=${name}&isUsed=${isUsed}`);
  }

  async updateRegion(id, name, isUsed) {
    return await authAxios.post(
      `/aet/region/update-region?id=${id}&name=${name}&isUsed=${isUsed}`
    );
  }

  /* AET DATES */

  async getAllDatesFromNow() {
    return await authAxios.get("/aet/date/get-all-from-now");
  }

  async getAllDates() {
    return await authAxios.get("/aet/date/get-all");
  }

  async getDateById(id) {
    return await authAxios.get(`/aet/date/get-by-id?id=${id}`);
  }

  async deleteDate(id) {
    return await authAxios.delete(`/aet/date/delete-date?id=${id}`);
  }

  async createDate(data) {
    return await authAxios.post(`/aet/date/create-date`, data);
  }

  async updateDate(id, data) {
    return await authAxios.post(`/aet/date/update-date?id=${id}`, data);
  }

  /* AET REQUESTS  */

  async getAllRequests() {
    return await authAxios.get("/aet/request/get-all");
  }

  async getAllRequestsByPrincipal() {
    return await authAxios.get("/aet/request/get-by-principal");
  }

  async checkAttemps() {
    return await authAxios.get("/aet/request/check-attemps");
  }

  async getRequestsForThisYear() {
    return await authAxios.get("/aet/request/get-for-year");
  }

  async createRequest(data) {
    return await authAxios.post("/aet/request/create-request", data);
  }

  async cancelRequest(requestId) {
    return await authAxios.get(
      `/aet/request/cancel-request?requestId=${requestId}`
    );
  }

  async cancelRequestForMarketing(requestId) {
    return await authAxios.get(
      `/aet/request/cancel-request-for-marketing?requestId=${requestId}`
    );
  }

  async getRequestsByFilter({
    applicationYear,
    regionId,
    dateId,
    page,
    keyword,
  }) {
    return await authAxios.get(
      `/aet/request/filter?application_year=${applicationYear}&region_id=${regionId}&date_id=${dateId}&page=${page}&keyword=${keyword}`
    );
  }

  async getExcelRequests({ applicationYear, regionId, dateId, keyword }) {
    return await authAxios.get(
      `/aet/request/get-excel-file?application_year=${applicationYear}&region_id=${regionId}&date_id=${dateId}&keyword=${keyword}`,
      { responseType: "blob" }
    );
  }

  async getCsvRequests({ applicationYear, regionId, dateId, keyword }) {
    return await authAxios.get(
      `/aet/request/get-csv-file?application_year=${applicationYear}&region_id=${regionId}&date_id=${dateId}&keyword=${keyword}`,
      { responseType: "blob" }
    );
  }

  /*  AET RESULTS   */

  async getResultByRequest(id) {
    return await authAxios.get(`/aet/result/get-by-request?requestId=${id}`);
  }

  async getResultsByFilter({
    applicationYear,
    regionId,
    dateId,
    page,
    keyword,
  }) {
    return await authAxios.get(
      `/aet/result/get-by-filter?application_year=${applicationYear}&region_id=${regionId}&date_id=${dateId}&page=${page}&keyword=${keyword}`
    );
  }

  async getResultFromAetModulByDateId(id) {
    return await authAxios.get(`/aet/result/get-by-date-id?dateId=${id}`);
  }

  async getExcelResults({ applicationYear, regionId, dateId, keyword }) {
    return await authAxios.get(
      `/aet/result/get-excel-file?application_year=${applicationYear}&region_id=${regionId}&date_id=${dateId}&keyword=${keyword}`,
      { responseType: "blob" }
    );
  }
}

export default AetService;
